export function createPromisable() {
  const promiseLike: any = {};
  promiseLike.promise = new Promise((resolve, reject) => {
    promiseLike.resolve = resolve;
    promiseLike.reject = reject;
  });
  return promiseLike as { promise: Promise<void>, resolve: any, reject: any }
}
